import { useRef } from 'react';
import { jobs, lenses, resumeUrl } from './data';
import { useScrollLine } from './hooks';
import Reveal from './Reveal';
import SectionHead from './SectionHead';

const WASH = ['#67e8f9', '#fbbf24', '#818cf8', '#34d399', '#f472b6', '#94a3b8'];

export default function Experience() {
  const lineRef = useRef(null);
  useScrollLine(lineRef);

  return (
    <section className="section" id="experience">
      <div className="wrap">
        <SectionHead
          index="02"
          label="Experience"
          title="Where the work happened."
          lede="Newest role first, back to the first internship."
        />
        <div className="path" ref={lineRef}>
          <div className="path__rail" aria-hidden="true">
            <i />
          </div>
          {jobs.map((job, index) => (
            <Reveal as="article" className="path__item" key={job.id}>
              <div className="path__card" style={{ '--wash': WASH[index % WASH.length] }}>
                <p className="path__when">{job.period}</p>
                <h3>{job.role}</h3>
                <p className="path__org">{job.org}</p>
                <p>{job.points[0]}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="skillband">
          {lenses.map((lens) => (
            <div className="skillband__group" key={lens.id}>
              <h3>{lens.title}</h3>
              <ul className="chips">
                {lens.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <p className="edu-line">
          B.Tech (Hons.) Data Science and AI, Sage University, Indore · 2020 to 2024 · CGPA 8.6 ·{' '}
          <a href={resumeUrl} target="_blank" rel="noreferrer">
            Resume
          </a>
        </p>
      </div>
    </section>
  );
}
